import { useEffect } from "react";
import { Layout } from "@/components/layout/Layout";
import { AnimatedSection, AnimatedHeading } from "@/components/ui/AnimatedSection";
import { SEO } from "@/components/SEO";

export default function Impressum() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://legal.flh-mediadigital.de/rewe-partner.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return (
    <Layout>
      <SEO title="Impressum | REWE V. Gahndi" description="Impressum und Anbieterkennzeichnung der REWE Vigheshan Gahndi oHG." path="/impressum" />
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <AnimatedHeading as="h1">
            <span className="text-gold-gradient">Impressum</span>
          </AnimatedHeading>

          <AnimatedSection>
            <div className="prose prose-invert prose-gold max-w-none space-y-8 text-center lg:text-left">
              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Angaben gemäß § 5 DDG
                </h2>
                <address className="not-italic text-muted-foreground space-y-1">
                  <p className="font-semibold text-foreground">REWE Vigheshan Gahndi oHG</p>
                  <p>Industriestraße 40</p>
                  <p>65439 Flörsheim-Weilbach</p>
                </address>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Vertreten durch die vertretungsberechtigten Gesellschafter
                </h2>
                <div className="text-muted-foreground space-y-4">
                  <p className="font-semibold text-foreground">Vigheshan Gahndi</p>
                  <div id="rewe-partner-data" className="text-muted-foreground leading-relaxed" />
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Kontakt
                </h2>
                <div className="text-muted-foreground space-y-1">
                  <p>Telefon: +49 6145 321455</p>
                  <p>E-Mail: vigheshan.gahndi@rewe-kaufleute.com</p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Registereintrag
                </h2>
                <div className="text-muted-foreground space-y-1">
                  <p>Eintragung im Handelsregister</p>
                  <p>Registergericht: Amtsgericht Wiesbaden</p>
                  <p>Registernummer: HRA 11122</p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Umsatzsteuer-ID
                </h2>
                <div className="text-muted-foreground">
                  <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:</p>
                  <p className="font-medium text-foreground mt-2">DE 332 586 129</p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Zuständige Aufsichtsbehörde
                </h2>
                <div className="text-muted-foreground space-y-1">
                  <p>Lebensmittelüberwachung Hofheim</p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
                </h2>
                <address className="not-italic text-muted-foreground space-y-1">
                  <p className="font-semibold text-foreground">Vigheshan Gahndi</p>
                  <p>Industriestraße 40</p>
                  <p>65439 Flörsheim-Weilbach</p>
                </address>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Datenschutzbeauftragter
                </h2>
                <address className="not-italic text-muted-foreground space-y-1">
                  <p className="font-semibold text-foreground">REWE Markt GmbH</p>
                  <p>Datenschutzbeauftragter</p>
                  <p>Domstr. 20</p>
                  <p>50668 Köln</p>
                  <p className="mt-2">E-Mail: datenschutz@rewe.de</p>
                </address>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Streitschlichtung
                </h2>
                <div className="text-muted-foreground space-y-4">
                  <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) 
                    bereit:{" "}
                    <a 
                      href="https://ec.europa.eu/consumers/odr/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:text-gold-light"
                    >
                      https://ec.europa.eu/consumers/odr/
                    </a>
                  </p>
                  <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Haftung für Inhalte
                </h2>
                <div className="text-muted-foreground space-y-4">
                  <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen
                    Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind
                    wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
                    fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                    rechtswidrige Tätigkeit hinweisen.
                  </p>
                  <p>
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach 
                    den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung 
                    ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung 
                    möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
                    Inhalte umgehend entfernen.
                  </p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Haftung für Links
                </h2>
                <div className="text-muted-foreground space-y-4">
                  <p>
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                    keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                    Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                    Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                  <p>
                    Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche 
                    Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                    Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten 
                    Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht 
                    zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links 
                    umgehend entfernen.
                  </p>
                </div>
              </div>

              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">
                  Urheberrecht
                </h2>
                <div className="text-muted-foreground space-y-4">
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                    unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                    Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                    bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                  <p>
                    Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen 
                    Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber 
                    erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden 
                    Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
                    Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden 
                    Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte 
                    umgehend entfernen.
                  </p>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </Layout>
  );
}
